import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { ACCOUNT_KEY } from '../../../providers/AccountProvider'
import { useEnvironment } from '../../../providers/EnvironmentProvider'

import useStyles from './styles'

const NoPermission = () => {
  const classes = useStyles()
  const { user } = useEnvironment()
  const { logout } = useAuth0()

  const back = React.useCallback(() => {
    window.location.href = '/'
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('session_user')
    localStorage.removeItem('session_token')
    localStorage.removeItem('version')
    localStorage.removeItem(ACCOUNT_KEY)
    logout({ logoutParams: { returnTo: `${window.location.origin}/login` } })
  }

  return (
    <div className={classes.root}>
      <div className={classes.bgHolder}>
        <img src='/imgs/BG.jpg' alt='BG' className='bg' />
      </div>

      <div className={classes.box}>
        <h1 style={{ marginBottom: '4rem' }}>{`User ${
          user?.auth?.email || ''
        } does not have access to this environment.`}</h1>

        <p className={classes.info}>
          You can{' '}
          <span className={classes.back} onClick={back}>
            return home
          </span>{' '}
          or{' '}
          <span className={classes.back} onClick={handleLogout}>
            sign out
          </span>
        </p>
      </div>
    </div>
  )
}

export default NoPermission
